import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { EpErrorService } from '@isophi/core-ui';
import { OrganizationService } from '@isophi/mng-api';
import { TranslocoService } from '@jsverse/transloco';
import { NgxSpinnerService } from 'ngx-spinner';
import { catchError, map, of, shareReplay, tap } from 'rxjs';

import { HelperService } from '../../../../core/services/helper.service';

@Component({
  selector: 'app-organization-workplaces',
  templateUrl: './organization-workplaces.component.html',
  styleUrls: ['./organization-workplaces.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class OrganizationWorkplacesComponent {
  private readonly helperService = inject(HelperService);
  private readonly translocoService = inject(TranslocoService);
  private readonly organizationService = inject(OrganizationService);
  private readonly spinner = inject(NgxSpinnerService);
  private readonly epErrorService = inject(EpErrorService);

  protected readonly organizationWorkplaces$ = this.organizationService.organizationWorkplacesRetrieve().pipe(
    tap(() => this.spinner.hide()),
    catchError((errorResponse) => {
      this.spinner.hide();
      this.epErrorService.handleEpErrorResponse(errorResponse, {
        defaultMessage: this.translocoService.translate('settings/workplacesError'),
      });
      return of(null);
    }),
    shareReplay({ refCount: true, bufferSize: 1 })
  );

  protected readonly totalChildrenCount$ = this.organizationWorkplaces$.pipe(
    map((workplace) => {
      if (!workplace || !workplace.workplaces?.length) {
        return 0;
      }

      return workplace.workplaces.reduce((acc, place) => acc + place.childrenCount, 0);
    }),
    shareReplay({ refCount: true, bufferSize: 1 })
  );
  protected readonly totalTeachersCount$ = this.organizationWorkplaces$.pipe(
    map((workplace) => {
      if (!workplace || !workplace.workplaces?.length) {
        return 0;
      }

      return workplace.workplaces.reduce((acc, place) => acc + place.teachersCount, 0);
    }),
    shareReplay({ refCount: true, bufferSize: 1 })
  );
  constructor() {
    this.spinner.show();
    this.helperService.setTitle(null, this.translocoService.translate('settings/organizationAndLicenses'));
  }
}
